import humps from 'humps'

export default () => {
  let fields = [];
  const valueTypes = {
    DEFAULT: 'default',
    ARRAY: 'array',
    OBJECT: 'object',
    UNDEFINED: 'undefined'
  }

  const checkValueType = (value) => {
    if (typeof value === 'string' ||
      typeof value === 'number' ||
      typeof value === 'boolean' ||
      value instanceof File) {
      return valueTypes.DEFAULT
    }
    if (Array.isArray(value)) {
      return valueTypes.ARRAY
    }

    if (value && typeof value === 'object') {
      return valueTypes.OBJECT
    }
    return valueTypes.UNDEFINED
  }

  const checkValue = (value) => {
    if (value === undefined) return false
    if (typeof value === 'string' && value === '') return false
    if (typeof value === 'number' && value < 0) return false
    return true
  }

  const getFormDataValueDefault = (value, field) => {
    const decamelizeField = humps.decamelize(field)
    return {
      field: decamelizeField,
      value
    }
  }

  const getFormDataValueArray = (values, field) => {
    const arr = []

    values.forEach((e, index) => {
      const callback = getActionByType(checkValueType(e))
      const fieldName = `${field}[${index}]`
      const value = callback(e, fieldName)
      if (value !== undefined) {
        if (Array.isArray(value)) {
          arr.push(...value)
        } else {
          arr.push(value);
        }
      }
    })
    return arr
  }

  const getFormDataValueObject = (value, field) => {
    let arr = []    

    const addValue = (v) => {
      if (typeof v.field === 'string') {
        const regexResult = v.field.replace(/\[|\]/gi, '.');
        let arrRegex = regexResult.split('.').filter((e) => e !== undefined && e !== '');
        const dField = humps.decamelize(field);

        arrRegex.unshift(dField);
        
        let resultField = '';
        
        arrRegex.forEach((e, index) => {
          resultField += index === 0 ? e : `[${e}]`;
        })
        
        arr.push({
          field: resultField,
          value: v.value,
        })
      }
    }

    for(const [key, val] of Object.entries(value)) {
      if (checkValue(val)) {
        const callback = getActionByType(checkValueType(val))
        const valueCallback = callback(val, key); 

        if (valueCallback) {
          if (Array.isArray(valueCallback)) {
            valueCallback.forEach((e) => {
              addValue(e)
            })
          } else if (typeof valueCallback === 'object') {
            addValue(valueCallback)
          }
        }
      }
    }

    return arr;
  }

  const getActionByType = (type) => {
    if (type === valueTypes.DEFAULT) {
      return getFormDataValueDefault
    }
    if (type === valueTypes.ARRAY) {
      return getFormDataValueArray
    }
    if (type === valueTypes.OBJECT) {
      return getFormDataValueObject
    }
    if (type === valueTypes.UNDEFINED) {
      return () => undefined
    }
  }  

  const getArrayByValue = (value, sourceArr) => {
    const temp = sourceArr;

    if (!value) return temp;

    if (Array.isArray(value)) {
      temp.push(...value)
    } else if (typeof value === 'object') {
      temp.push(value)
    } else {
      temp.push({ field: 'undefined', value })
    }

    return temp;
  }

  const getArrFormData = (targetObject) => {
    let arrFormDataValues = [];

    if (targetObject) {
      for (let i = 0; i < fields.length; i += 1) {
        if (checkValue(targetObject[fields[i]])) {
          const callback = getActionByType(checkValueType(targetObject[fields[i]]))
          const value = callback(targetObject[fields[i]], fields[i])
          arrFormDataValues = getArrayByValue(value, arrFormDataValues)
        }
      }
    }

    return arrFormDataValues
  }



  const getFormData = (targetObject) => {
    const fData = new FormData();

    const arrFormData = getArrFormData(targetObject)
    
    arrFormData.forEach((e) => {
      if (e.value !== undefined && e.value !== '') {
        fData.append(e.field, e.value)
      }
    })
    return fData
  }

  const setFields = (arrFields) => {
    if (arrFields?.length > 0) {
      fields = arrFields
    }

    return { getFormData, getArrFormData }
  }

  const execute = () => {
    return {
      setFields
    }
  }

  return {
    execute,
  }
}